import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { RootStoreContext } from "../../../../../app/stores/rootStore";

const Dashboard = ({ projectId }) => {
  const navigate = useNavigate();
  const { screeningStore } = useContext(RootStoreContext);
  const { dashboardStats, loadingDashboard, fetchDashboard } = screeningStore;

  useEffect(() => {
    fetchDashboard(projectId);
  }, [projectId, fetchDashboard]);

  const handleNewWorkflow = () => {
    navigate("editor/new");
  };

  const quickEntries = [
    { icon: "🔌", label: "Docking", desc: "分子对接" },
    { icon: "🧬", label: "分子生成", desc: "AI 生成" },
    { icon: "💊", label: "ADMET", desc: "性质预测" },
    { icon: "📐", label: "RDKit", desc: "描述符" },
  ];

  const stats = dashboardStats || { totalWorkflows: 0, runningRuns: 0, completedRuns: 0, recentActivities: [] };
  const recentActivities = stats.recentActivities || [];

  // Map status to display
  const getActivityState = (workflow) => {
    const name = workflow.name || "Untitled";
    const time = workflow.lastEditAt
      ? new Date(workflow.lastEditAt).toLocaleString()
      : "";
    // Determine status emoji from runs - simplified for now
    return { name, time, state: workflow.status === "Draft" ? "Draft" : "Saved" };
  };

  return (
    <div className="fadein animation-duration-500" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      {/* SectionHeading-style header bar */}
      <div className="screening-header">
        <span className="screening-header-icon">🔬</span>
        <span className="screening-header-title">Screening</span>
        <div className="screening-header-buttons">
          <Button
            label="⚡ New Workflow"
            icon="pi pi-plus"
            className="screening-header-btn-primary"
            onClick={handleNewWorkflow}
          />
          <Button
            label="Import"
            icon="pi pi-upload"
            className="screening-header-btn"
          />
        </div>
      </div>

      <div className="screening-body">
        {/* Stats Cards */}
        <div className="screening-stats">
          <div className="screening-stat-card">
            <div className="screening-stat-icon">📋</div>
            <div>
              <div className="screening-stat-number">{stats.totalWorkflows}</div>
              <div className="screening-stat-label">Total Workflows</div>
            </div>
          </div>
          <div className="screening-stat-card">
            <div className="screening-stat-icon">▶️</div>
            <div>
              <div className="screening-stat-number">{stats.runningRuns}</div>
              <div className="screening-stat-label">Running</div>
            </div>
          </div>
          <div className="screening-stat-card">
            <div className="screening-stat-icon">✅</div>
            <div>
              <div className="screening-stat-number">{stats.completedRuns}</div>
              <div className="screening-stat-label">Completed</div>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="screening-activity">
          <div className="screening-section-title">Recent Activity</div>
          <div className="screening-activity-list">
            {loadingDashboard ? (
              <div className="screening-activity-item">
                <span style={{ color: "#94a3b8" }}>Loading...</span>
              </div>
            ) : recentActivities.length === 0 ? (
              <div className="screening-activity-item">
                <span style={{ color: "#94a3b8" }}>No workflows yet. Create one!</span>
              </div>
            ) : (
              recentActivities.map((act, i) => {
                const { name, time, state } = getActivityState(act);
                return (
                  <div key={i} className="screening-activity-item" onClick={() => navigate(`editor/${act.id}`)}>
                    <div className="screening-activity-status">📄</div>
                    <div className="screening-activity-info">
                      <div className="screening-activity-name">{name}</div>
                      <div className="screening-activity-meta">{time} · {state}</div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Quick Entries */}
        <div>
          <div className="screening-section-title">Quick Start</div>
          <div className="screening-quick-grid">
            {quickEntries.map((item, i) => (
              <div key={i} className="screening-quick-card" onClick={handleNewWorkflow}>
                <div className="screening-quick-icon">{item.icon}</div>
                <div className="screening-quick-label">{item.label}</div>
                <div style={{ fontSize: "0.75rem", color: "#94a3b8", marginTop: 4 }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Dashboard);
